/* eslint-disable */
// @ts-nocheck

import React, { useEffect, useState } from "react";
import { Tooltip } from "@carbon/react";
import { ReactComponent as InfoIcon } from "../../assets/icons/info.svg";

interface IProps {
  label?: string;
  fieldName?: string;
}

const computeAlign = (window, x, y) => {
  const yPos = y < 200 ? "bottom" : "top";
  const xPos = window.innerWidth - x < 250 ? "right" : "left";
  return yPos + "-" + xPos;
};

const FieldTooltip = ({ label, fieldName }: IProps) => {
  const [x, setX] = useState(400);
  const [y, setY] = useState(400);

  return (
    <>
      <Tooltip
        label={label}
        align={computeAlign(window, x, y)}
        data-cy={`${fieldName}tooltip`}
      >
        <button
          className="cds--tooltip__trigger"
          type="button"
          data-cy={`${fieldName}tooltip-button`}
        >
          <div
            ref={(el) => {
              if (!el) return;
              setX(el.getBoundingClientRect().x);
              setY(el.getBoundingClientRect().y);
            }}
          >
            <InfoIcon />
          </div>
        </button>
      </Tooltip>
    </>
  );
};

export default FieldTooltip;
